import { useApiQuery } from '../useApiQuery';
import { creditMemoKeys } from '@/lib/queryKeys';
import { creditMemoEndpoints } from '@/lib/api/endpoints';
import { apiGet, operationsClient } from '@/lib/api/client';
import type { CreditMemo } from '@/types/creditMemo';
import { normalizeCreditMemo } from './useCreditMemos';

export function useCreditMemo(id: string, options?: { enabled?: boolean }) {
  return useApiQuery<CreditMemo>({
    queryKey: creditMemoKeys.detail(id),
    queryFn: async () => {
      const raw = await apiGet<Record<string, unknown>>(
        operationsClient,
        creditMemoEndpoints.detail(id),
      );
      return normalizeCreditMemo(raw);
    },
    enabled: (options?.enabled ?? true) && Boolean(id),
    showErrorToast: false,
  });
}
